<template>
  <div>
    <v-layout row wrap align-center justify-center class="mt-3">
      <v-flex xs12 sm6 md5 lg5>
        <v-hover>
          <v-card
            class="text-xs-center ma-3"
            slot-scope="{ hover }"
            :class="`elevation-${hover ? 12 : 2}`"
          >
            <v-card-title>
            <v-layout row wrap align-center justify-center class="mt-2"> 
              <span class="headline font-weight-bold">Confirming the link to the wireframe:</span> 

              <v-alert
                :value="true"
                color="primary"
                icon="info"
                class="caption text-lg-justify mt-3"
                outline>
                Tip: For the prefered solution concept, a wireframe can be developed using a service such as AdobeXD or Marvel App. The purpose of this is to have the End user(s) interact with it, with the goal of eventually collecting feedback from them.
                
              </v-alert>
              <v-btn flat small :href="linktolfwireframe" target="_blank" class="mx-2 font-weight-light" align-center justify-center>Learn more about Wireframes</v-btn> 
              </v-layout>
            </v-card-title>
            <v-card-text>
              <v-form class="px-3" ref="form">
                <!-- <span v-for="(customerproblemdetail, index) in customerproblemdetails" :key="index"> -->
                  <!-- <v-layout row wrap>  -->

                 <v-textarea
                  outline   
                  class="height-issue-fix"
                  :height="70"
                  :rules="textInputRules"
                  :label="linktowireframeLabel"
                  v-model="linktolfwireframe"
                  
                >
                 </v-textarea> 

                 




                
                

                <v-spacer></v-spacer>
                <v-btn flat @click="$router.go(-1)" class="mx-4 mt-3">Head back</v-btn>
              <!--  <v-btn flat @click="submit" color="primary" class="mx-2 mt-3" :loading="loading">Head to Share links</v-btn>-->
                 <!-- <v-btn to="/addevangelistsandearlyadopters" flat color="primary" class="mx-2 mt-3" :loading="loading">Confirm and Go on</v-btn>   -->
                 <v-btn to="/addevangelistsandearlyadopters" flat color="primary" class="mx-2 mt-3" :loading="loading">Go Next</v-btn>  
                
              </v-form>
            </v-card-text>
          </v-card>
        </v-hover>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import db from '../fb'
import gvars from '../globalvariables'

export default {
  name: "problemstudy",
  components: {},
  data() {
    return { 
      linktolfwireframe: 'https://marvelapp.com/1d4dj00g',  
      doWe: false,
      linktowireframeLabel:'If a wireframe is already created, please enter the link to it here',
      innovationdistributionmedium: 'The Web',
      innovationdistributionmediumLabel:'What medium would you choose to share the wireframes with users?',
      innovationdistributionmediumHint: '*An appropriate medium, if selected will help the early adopters and other users with quicker access to the solution concept and subsequently provide feedback more quickly',
      //metrictitle: 'Potential customer conversions per month',
      
      textInputRules: [
        v => !!v || 'This field is required',
        v => v.length >= 3 || 'Minimum length is 3 characters'
      ],
      selectInputRules: [
        v => !!v || 'This field is required'
      ],
      loading: false
    }
  },
  methods: {
    submit(){
 if(this.$refs.form.validate()) {
            //console.log(this.nameofthesolution, this.briefdescriptionofthesolution)
            this.loading = true;
             

            const linktowf = {
                linktolfwireframe: this.linktolfwireframe, 
                innovationdistributionmedium: this.innovationdistributionmedium
            }
 

            db.collection('projects').doc(this.getProjectID()).update(linktowf).then(() => {
                    //console.log("added to db!", docRef.id)
                    this.loading = false;
                    this.dialog = false;
                    this.$router.push('addevangelistsandearlyadopters')
                    ///this.$emit('firstprefdetailsconfirmed')
                });


           const metric = {
                metrictitle: this.metrictitle,
                metriccategory: 'Evangelism'
            }
 

            //Yx3r6dHUeFFdGvY6Acvy

           db.collection('projects').doc(this.getProjectID()).collection('metrics').add(metric).then(() => {
          //console.log("added to db!", docRef.id)
          //nameofthesolution = '';
          //briefdescriptionofthesolution = '';
          this.loading = false;
          this.dialog = false;
          //this.$emit('projectadded')
       });


            //Yx3r6dHUeFFdGvY6Acvy
 

             }

    },
    getProjectID(){
      return gvars.PROJECTID;
    }
    
  },
  computed: {
    
  }
};
</script>

<style>
.height-issue-fix > div > .v-input__slot {
    min-height: 100% !important;
    max-height: 100%;
    margin-bottom: 0.2em;
  }

  .height-issue-fix fieldset {
    top: 0 !important;
    height: inherit;
  }
  
  .height-issue-fix fieldset legend {
    display:none;
  }
  
  .height-issue-fix .v-text-field__slot {
    height: inherit;
  }
  
  .height-issue-fix .v-input__append-inner {
    height: inherit;
    align-items: center;
    align-self: unset !important;
  }
</style>
